/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsSetApiKey } from "../../funcs/budgetsSetApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SetApiKeyBudgetRequest$inboundSchema,
};

export const tool$budgetsSetApiKey: ToolDefinition<typeof args> = {
  name: "budgets-set-api-key",
  description: `Set an apikey budget

Creates or updates a budget for the apikey. One budget per (scope, owner); editing re-evaluates against live spend. Callable by cluster admins, or org admins for API keys in their own organization.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsSetApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
